import * as io from 'io-ts';
import { nullable, arrayOfStrings, boolean, nullableString, validString } from '@shared/core/types/common';
import { checkoutStepEnum, defaultForEmptyOrderType, orderTypeIdsArray } from '@shared/core/types/consts';

const dynamicOrderTypeDetailsCTADefinition: io.MixedObject<OLO.Config.DynamicOrderTypeDetailsCTA> = {
    icon: validString,
    text: validString,
};

const dynamicOrderTypeDetailsModalDefinition: io.MixedObject<OLO.Config.DynamicOrderTypeDetailsModal> = {
    preTitle: validString,
    title: arrayOfStrings,
    description: arrayOfStrings,
};

const dynamicOrderTypeDetailsDefinition: io.MixedObject<OLO.Config.DynamicOrderTypeDetails> = {
    associateWithPaymentStep: checkoutStepEnum,
    addDetailsButtonText: validString,
    dataCollected: arrayOfStrings,
    callToAction: io.type(dynamicOrderTypeDetailsCTADefinition),
    modal: nullable(io.type(dynamicOrderTypeDetailsModalDefinition)),
};

const rootDefinition: io.MixedObject<OLO.Config.CheckoutPage> = {
    orderTypeIds: orderTypeIdsArray,
    orderTypesDisclaimers: boolean,
    allowGuestsOrders: boolean,
    mediaSectionHeader: io.union([nullableString, defaultForEmptyOrderType]),
    isMemberInterfaceEnabled: boolean,
    dynamicOrderTypeDetails: io.union([nullable(io.type(dynamicOrderTypeDetailsDefinition)), defaultForEmptyOrderType]),
};

export const checkoutPageSchema = io.array(io.type(rootDefinition));
